import { GripVertical, RotateCcw } from "lucide-react";
import { cn } from "@/lib/cn";

type Props = {
  reordenando: boolean;
  personalizado: boolean;
  collapsed: boolean;
  onEntrar: () => void;
  onConcluir: () => void;
  onRestaurar: () => void;
};

/** Entrada e saída do modo Reorganizar. Fica no rodapé porque é ajuste de uma vez só — no topo
 *  competiria com o seletor de organização, que a pessoa usa todo dia. */
export function SidebarRodape({
  reordenando,
  personalizado,
  collapsed,
  onEntrar,
  onConcluir,
  onRestaurar,
}: Props) {
  return (
    <div className={cn("shrink-0 border-t border-border p-2", collapsed && "md:hidden")}>
      {reordenando ? (
        <div className="flex flex-col gap-1">
          <p className="px-1.5 pb-0.5 text-[11px] leading-snug text-muted-foreground">
            Arraste pela alça. Salva sozinho, na sua conta.
          </p>
          <div className="flex items-center gap-1">
            <button
              type="button"
              onClick={onConcluir}
              className="flex-1 rounded-md bg-primary px-2 py-1.5 text-[12px] font-medium text-primary-foreground transition-colors hover:bg-brand-700"
            >
              Concluir
            </button>
            <button
              type="button"
              onClick={onRestaurar}
              disabled={!personalizado}
              title="Voltar à ordem padrão"
              aria-label="Voltar à ordem padrão"
              className="flex h-[30px] w-8 items-center justify-center rounded-md border border-zinc-200 text-muted-foreground transition-colors hover:bg-zinc-50 disabled:opacity-40 dark:border-border dark:hover:bg-muted"
            >
              <RotateCcw className="h-3.5 w-3.5" />
            </button>
          </div>
        </div>
      ) : (
        <button
          type="button"
          onClick={onEntrar}
          className="flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-[12px] text-muted-foreground transition-colors hover:bg-zinc-50 hover:text-foreground dark:hover:bg-muted"
        >
          <GripVertical className="h-3.5 w-3.5 shrink-0" />
          <span className="truncate">Reorganizar menu</span>
        </button>
      )}
    </div>
  );
}
